module.exports = __webpack_public_path__ + "triangle-right-gray.svg?aba9187925b477d90592158307d8abaf";